
/*
    Display a list of elements which can each be individually expanded

    This component wraps around them and ensures that one one such element
    in the list is expanded at any given time, closing all others when a 
    new one is set to be expanded
*/

import React from "react";

import MainContext from "../MainContext";

/*
keep track of which index is opened

--> just have a method to close all, including the filter
    and then just run the next method as a callback

so would I handle opening/closing other forms (like add user, add lane)
with the callback, or tie that into this?

*/

/*
PROPS:
    data
    component
    keyField
*/

//
// convert context into props for the sake of updating
//
// export default (props) => {

//     const context = useContext(MainContext);
//     return <SingleOpenList runClose={context.filterOpen} {...props} />
// }

export default class SingleOpenList extends React.Component {

    static contextType = MainContext;

    state = {
        openIndex: null
    }

    //
    // close all elements within the list, then open the specific index
    // (or none if the index is left out)
    //
    closeAllThenOpen = (index) => {
        // if we're given a prependCall prop,
        // then call that function before going through the open/close operation
        if(index !== null && this.props.prependCall && typeof this.props.prependCall === "function"){
            this.props.prependCall(() => {
                this.setState({openIndex: index}, () => {
                    // close the filter while we're at it, too
                    if(index !== null && this.props.callback && typeof this.props.callback === "function"){
                        this.props.callback();
                    }
                });
            })
        }
        else{
            this.setState({openIndex: index}, () => {
                // close the filter while we're at it, too
                if(index !== null && this.props.callback && typeof this.props.callback === "function"){
                    this.props.callback();
                }
            });
        }
    }

    // if the filter opens, then close everything in here
    componentDidUpdate(prevProps){
        if(this.props.forceClose && !prevProps.forceClose){
            this.closeAllThenOpen(null);
        }
    }

    render() {
        return (
            <>
                {
                    this.props.data && this.props.component
                    ? this.props.data.map((obj, index) => {
                        const expanded = index === this.state.openIndex;

                        // here's the main magic:
                        // dynamically display the list elements,
                        // passing in the data
                        // expansion status of this element
                        // and functions for opening/closing

                        return React.createElement(this.props.component, 
                            {
                                key: this.props.keyField ? this.props.data[this.props.keyField] : index, 
                                index,
                                data: obj, 
                                expanded, 
                                containerIndex: index, 
                                runOpen: this.closeAllThenOpen,
                                ...this.props.props
                            });
                    })
                    : null
                }
            </>
        )
    }
}
